// ClassView.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const ClassView = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/class/${id}`).then(r => setData(r.data));
  }, [id]);

  if (!data) return <div className="text-center mt-4">Yükleniyor...</div>;

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h5 className="mb-3 fw-bold">Sınıf Detayı</h5>
        {data.cover && (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL}${data.cover}`}
            alt="cover"
            className="img-thumbnail mb-3"
            style={{ maxWidth: 200 }}
          />
        )}
        <p><strong>Başlık:</strong> {data.title}</p>
        <p><strong>Oluşturulma:</strong> {new Date(data.created_at).toLocaleDateString("tr-TR")}</p>
      </div>
    </div>
  );
};

export default ClassView;